import Vue from 'vue'
import VueRouter from 'vue-router'
import vueXstore from '@/store/index';
import authService from '../services/authService';

Vue.use(VueRouter)


let routes = [
	{
		path: '*',
		name: 'page404',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboard',
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
	},
	{
		path: '/dashboard',
		name: 'Portal',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../muic/portal/mainportal.vue'),
	},
	// my muic : router
	{
		path: '/calendar',
		name: 'Calendar',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/calendar/mainevent.vue'),
	},
	{
		path: '/chatmessage',
		name: 'Chat assistant "Copter"',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/assischat/chatmessage.vue'),
	},
	// project plan
	//
	{
		path: '/orientation',
		name: 'Orientation Check-in',
		layout: "default",
		meta: {
			requiresAuth: false,
			permission: ['student', 'students']
		},
		component: () => import('../muic/Orentation/main_student.vue'),
	},
	{
		path: '/stage',
		name: 'Orientation Stage',
		layout: "layout-sign-up",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/device/orentation_stage.vue'),
	},
	{
		path: '/service',
		name: 'Service',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/service/service.vue'),
	},
	{
		path: '/service/form',
		name: 'Form create ticket',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/service/formticket.vue'),
	},
	{
		path: '/teaching',
		name: 'Teaching record',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/teaching/records.vue'),
	},
	{
		path: '/teaching/form',
		name: 'Teaching record submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/teaching/formrecord.vue'),
	},
	// vehicle
	{
		path: '/booking/vehicle',
		name: 'Vehicle',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/vehicle/main-vehicle.vue'),
	},
	{
		path: '/booking/vehicle/form',
		name: 'Vehicle submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/vehicle/formvehicle.vue'),
	},
	// photo booking
	{
		path: '/booking/pr/photo/form',
		name: 'Photo Booking Submission Form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/photo/form-photo.vue'),
	},
	{
		path: '/booking/pr/photo',
		name: 'Photo Booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/photo/main-photo.vue'),
	},
	// video booking
	{
		path: '/booking/pr/video/form',
		name: 'Video submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/video/form-video.vue'),
	},
	{
		path: '/booking/pr/video',
		name: 'Video booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/video/main-video.vue'),
	},
	// design booking
	{
		path: '/booking/pr/design/form',
		name: 'Design submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/design/form-design.vue'),
	},
	{
		path: '/booking/pr/design',
		name: 'Design booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/design/main-design.vue'),
	},
	// design printing
	{
		path: '/booking/pr/printing/form',
		name: 'Printing submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/printing/form-printing.vue'),
	},
	{
		path: '/booking/pr/printing',
		name: 'Printing Booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/printing/main-printing.vue'),
	},
	{
		path: '/tuitionpayment',
		name: 'Qr payment',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/payment/mainpay.vue'),
	},
	{
		path: '/directory',
		name: 'Directory',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			// , 'student'
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/directory/search.vue'),
	},
	{
		path: '/accesslog',
		name: 'Campus access log',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/accesslog/listaccess.vue'),
	},
	{
		path: '/smartauthen',
		name: 'Smart authen log',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/accesslog/smartauthen.vue'),
	},
	{
		path: '/studentactivity',
		name: 'Student Activity',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/studentaffairs/mainactivity.vue'),
	},
	{
		path: '/hri',
		name: 'Human Resources',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/mainhri.vue'),
	},
	{
		path: '/hri/request',
		name: 'Human Resources Request',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/chooserequest.vue'),
	},
	{
		path: '/booking',
		name: 'Booking Systems',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/BookingList.vue'),
	},
	{
		path: '/booking/pr',
		name: 'Service by Media Development Section',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/PrBookingList.vue'),
	},
	{
		path: '/hri/leaveofabsence',
		name: 'HRI / Leave Quota',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/leaveofabsence/leave.vue'),
	},
	{
		path: '/hri/request/flexible',
		name: 'Flexible',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_fixableday.vue'),
	},
	{
		path: '/hri/request/workfromhome',
		name: 'Work From Home',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_workforhome.vue'),
	},
	{
		path: '/hri/request/leaveofabsence',
		name: 'Leave of Absence',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_leave.vue'),
	},
	{
		path: '/hri/request/seminar',
		name: 'การขอไป อบรม / สัมมนา / ประชุม / ดูงาน',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_seminar.vue'),
	},
	{
		path: '/hri/request/otrequest',
		name: 'OT Management',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_ot.vue'),
	},
	{
		path: '/hri/request/absentTime',
		name: 'รายการคำขอบันทึกเวลาปฏิบัติงาน',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_savetime.vue'),
	},
	{
		path: '/hri/request/travelAbroad',
		name: 'เดินทางไปต่างประเทศของบุคลากร',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_travel.vue'),
	},
	{
		path: '/hri/request/hrdbudget',
		name: 'HRD Budget Report',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_hrd.vue'),
	},
	{
		path: '/profile-overview',
		name: 'profile-overview',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/summaryprofile.vue'),
	},
	{
		path: '/document-app',
		name: 'IC APP',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/documentapp/maindoc.vue'),
	},
	{
		path: '/parking',
		name: 'Parking Fees',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/parking/mainparking.vue'),
	},
	{
		path: '/lostandfound',
		name: 'Lost and Found',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/lostandfound/mainlost.vue'),
	},
	{
		path: '/Profile',
		name: 'Profile',
		layout: "dashboard",
		meta: {
			layoutClass: 'layout-profile',
			requiresAuth: true
		},
		component: () => import('../muic/profile/main.vue'),
	},
	// my muic : router 

	// maintance page Full-page
	{
		path: '/maintenancesys',
		name: 'maintenancesys',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/maintancepage/mainclosemy.vue'),
	},

	// device Full-page
	{
		path: '/support/welcome/',
		name: 'welcomesupport',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/support/main.vue'),
	},
	{
		path: '/timescan',
		name: 'timescan',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/timescan.vue'),
	},
	{
		path: '/smartauthenapp',
		name: 'smartauthenapp',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/smartauthenapp.vue'),
	},
	{
		path: '/smartauthenqr',
		name: 'reset-device-qr',
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/device/smartauthenqr.vue'),
	},
	{
		path: '/reset-device-app',
		name: 'reset-device-app',
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/documentapp/confirmuseapp.vue'),
	},
	{
		path: '/voteJob',
		name: 'voteJob',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/service/voteJob.vue'),
	},
	{
		path: '/eventcheckins',
		name: 'eventcheckins',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/eventscan.vue'),
	},
	// device Full-page
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		meta: {
			requiresAuth: true
		},
		component: () => import('../views/Layout.vue'),
	},
	{
		path: '/fullchat',
		name: 'Layout',
		// layout: "dashboard",
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/assischat/fullchat.vue'),
	},
	{
		path: '/timeclick',
		name: 'timeclick',
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/accesslog/timeclick.vue'),
	},
	{
		path: '/login',
		name: 'Login',
		layout: "default",
		meta: {
			requiresAuth: false,
			layout: 'default'
		},
		component: () => import('../views/Login.vue'),
	},
	{
		path: '/election',
		name: 'Election',
		layout: "default",
		meta: {
			requiresAuth: false,
			layout: 'default'
		},
		component: () => import('../muic/election/mainvote.vue'),
	},
	{
		path: '/organization-data',
		name: 'OrganizationData',
		layout: "default",
		meta: {
			requiresAuth: false,
			layout: 'default'
		},
		component: () => import('../muic/hri/organizationdata.vue'),
	},
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

const whoami = async () => {
	let textRole = 0
	const res = await Vue.axios.get('/whoami/')
	if (res.status === 200) {
		// MSAL Role mapping for students
		if (authService.getAccount() && res.data.roles && res.data.roles.includes('students')) {
			res.data.roles = ["student", "offline_access", "uma_authorization"];
		}

		for (const element of res.data.roles) {
			if (['student', 'students'].includes(element)) {
				textRole++
			}
		}
		return [res.data, textRole > 0 ? 'student' : 'staff'];
	}
	return false;
}


const STAFF_ONLY_PATHS = new Set([
	'/calendar', '/document-app', '/directory', '/hri', '/teaching', '/booking', '/profile-overview', '/leaveofabsence',
	'/teaching/form', '/booking/vehicle/form', '/booking/pr/photo/form', '/booking/pr/photo', '/booking/pr/video/form', '/booking/pr/video',
	'/hri/request/leaveofabsence', '/hri/request/travelAbroad', '/hri/request', '/hri/request/absentTime', '/hri/request/seminar', '/smartauthen', '/project_plan',
]);

const handleAuthenticatedUser = async (res, to, next) => {
	console.log("handleAuthenticatedUser", res[1]);
	vueXstore.dispatch('setRoleUser', {
		username: res[0].username,
		roles: res[0].roles,
		permissions: res[0].permissions,
		codeId: res[0].usercode,
		flexible: res[0].flexible,
		tel: res[0].tel,
	});

	if (to.path === '/stage' || (to.matched[0] && to.matched[0].path === '/stage')) {
		if (!to.meta.permission.includes(res[1])) {
			return next('/orientation');
		}
	}

	if (STAFF_ONLY_PATHS.has(to.matched[0]?.path)) {
		return res[1] === 'staff' ? next() : next('/');
	}

	return next();
};

const redirectToLogin = (path, next) => {
	if (path !== '/login') return next('/login');
	return next();
};

router.beforeEach(async (to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	// Ensure MSAL is initialized before checking account
	await authService.initialize();
	const isMsalAuth = authService.getAccount();
	const isKeycloakAuth = router.app.$keycloak?.authenticated;

	if (!requiresAuth) {
		// If already logged in and visiting login page, redirect to dashboard?
		// Optional enhancement, but for now just proceed
		return next();
	}

	if (!isKeycloakAuth && !isMsalAuth) {
		if (to.path !== '/login') {
			return next('/login');
		}
		return next();
	}

	let res = false;
	try {
		res = await whoami();
	} catch (e) {
		console.error("Whoami failed", e);
	}

	if (isKeycloakAuth || isMsalAuth) {  // Logic slightly adjusted: if either auth is present
		if (res) {
			return handleAuthenticatedUser(res, to, next);
		}
		// If whoami fails but we have token, maybe we should still allow? 
		// Or maybe whoami is required for roles?
		// Existing logic implies whoami result is needed for handleAuthenticatedUser
	}

	if (to.path !== '/login') {
		return next('/login');
	}
	return next();
})

export default router
